import {
  adjust, curry, filter, findIndex, flip, includes, keys,
  length, map, mergeLeft, pipe, pluck, propEq, uniq,
} from 'rambda'

export const hasKeys = pipe(keys, length, Boolean)

export const mergeLabelArrays = (objectsArray, labelsArray, mergeStringKey = 'label') =>
  objectsArray.map((object, index) => ({
    ...object,
    ...(typeof labelsArray[index] === 'object'
      ? labelsArray[index]
      : { [mergeStringKey]: labelsArray[index] }),
  }))

export const adjustBy = curry((condition, adjustment, list) => list
  .map(item => condition(item)
    ? adjustment(item)
    : item))

export const pluckUniq = pipe(
  pluck,
  uniq,
)

export const pluckTruthy = pipe(
  pluckUniq,
  filter(Boolean),
)

export const pluckId = pluckTruthy

export const pluckFlat = curry((key, array) =>
  pluck(key, array).flat())

export const pluckIds = (ids, array) =>
  map(key => pluckId(key, array), ids)

export const mergeIndex = (index, value, array) =>
  adjust(index, mergeLeft(value), array)

export const mergeItem = (item, value, array) =>
  adjust(array.indexOf(item), mergeLeft(value), array)

export const mergeByKey = curry((key, record, array) => adjust(
  findIndex(propEq(key, record[key]), array),
  mergeLeft(record),
  array,
))

export const mergeById = mergeByKey('id')

// NOTE: could be replaced with ramda.remove(_, 1)
export const removeIndex = (index, array) => array
  .filter((_, itemIndex) => itemIndex !== index)

// NOTE: could be replaced with ramda.without
export const removeItem = (itemToRemove, array) => array
  .filter(item => item !== itemToRemove)

export const removeById = (record, array) => removeIndex(
  findIndex(propEq('id', record.id), array),
  array,
)

// export const randomIn = (() => {
//   const randomIndex = array => Math.floor(Math.random() * (array.length - 1))

//   return array => array[randomIndex(array)]
// })()

export const mapNative = curry((mapper, array) => array.map(mapper))

export const byAsc = key => (a, b) => a[key] - b[key]
export const byDesc = key => (a, b) => b[key] - a[key]

export const normalizePositionKey = (() => {
  const addIndexKey = (offset, key) => items => items
    .map((item, index) => ({
      ...item,
      [key]: index + offset,
    }))

  const addPositionKey = addIndexKey(1, 'position')
  const sortByPositionAsc = byAsc('position')

  return items => addPositionKey([...items]
    .sort(sortByPositionAsc))
})()

export const getRandomItem = array => array[Math.floor(Math.random() * array.length)]

export const getRandomItemUnique = (array, currentValue) => {
  const randomPhrase = getRandomItem(array)

  if (randomPhrase === currentValue && array.length > 1) {
    return getRandomItemUnique(array)
  }

  return randomPhrase
}

export const toggleItem = curry((item, array) =>
  array.includes(item)
    ? removeItem(item, array)
    : [...array, item])

export const indexByProp = (prop, list) => {
  // manual curry for perf
  if (list === undefined) return list => indexByProp(prop, list)

  return Object
    .fromEntries(list
      .map(item => [item[prop], item]))
}

export const groupByProp = (key, list) => {
  // manual curry for perf
  if (list === undefined) {
    return list => groupByProp(key, list)
  }

  const groups = {}

  list.forEach((item) => {
    const subkey = String(item[String(key)])
    if (!groups[subkey]) {
      groups[subkey] = [item]
      return
    }

    groups[subkey].push(item)
  })

  return groups
}

export const includedIn = flip(includes)

// export const groupByPropIntoMap = (key, list) => {
//   // manual curry for perf
//   if (list === undefined) {
//     return list => groupByPropIntoMap(key, list)
//   }

//   const stringKey = String(key)
//   const groups = new Map()

//   list.forEach((item) => {
//     const subkey = item[stringKey]
//     const array = groups.get(subkey)

//     array
//       ? array.push(item)
//       : groups.set(subkey, [item])
//   })

//   return groups
// }
